import useUIState from './persistUiState';
import { UIArea } from './types';

export interface NavbarUIState {
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}

export const useNavbarUIState = (area: UIArea): NavbarUIState =>
  useUIState((state) => ({
    hidden: state.navBarHidden[area],
    setHidden: (hidden) => state.setNavBarHidden(area, hidden),
  }));
